export default __webpack_public_path__ + "c8189708eec5a6c49a813ac264aaf2b4.png";